<div fxLayout="column" class="heading">
    <span class="width">Payment Receipt</span>
    <p class="width">
        Thank you for your participation in Creatics as <b>{{pricingAndAccess?.title}}!</b>
    </p>
    <div class="main-div width" fxLayout="row wrap">
        <div class="information">
            <p>
                Status : Successful<br><br>
                Date : {{paymentDate | date:'MMMM d, y, h:mm:ss a'}} {{userTimezoneNameSP(paymentDate)}}
            </p>

            <p>Payment Type : Card Payment</p>
            <p>Currency: USD</p>
            <p>
                Amount : ${{pricingAndAccess?.amount}}<br><br>
                Transaction ID : {{transactionID}}<br><br>
            </p>
            <span (click)="goBack()">Return to Pricing And Access page</span>
        </div>
    </div>
</div>

